import { render, staticRenderFns } from "./GameReplayView.vue?vue&type=template&id=e4f9648a&scoped=true"
import script from "./GameReplayView.vue?vue&type=script&lang=js"
export * from "./GameReplayView.vue?vue&type=script&lang=js"
import style0 from "./GameReplayView.vue?vue&type=style&index=0&id=e4f9648a&prod&lang=scss&scoped=true"
import style1 from "./GameReplayView.vue?vue&type=style&index=1&id=e4f9648a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f9648a",
  null
  
)

export default component.exports